export enum ExpandLabelEnum {
  EXPAND = 'Visa alla',
  COLLAPSE = 'Förminska',
}
